// extracted by mini-css-extract-plugin
export default {"container":"History_container__E5lHK","table-placeholder":"History_table-placeholder__6CijQ"};